import { GeodesicLine } from 'leaflet.geodesic';

const base = new GeodesicLine([[0, 0]], {
  wrap: true,
});

export const distance = (latLngOne: number[], latLngTwo: number[]) => {
  if (latLngOne?.length !== 2 || latLngTwo?.length !== 2) {
    return NaN;
  }

  return base.distance(latLngOne as [number, number], latLngTwo as [number, number]);
};
